import { ZodError } from "zod";

function formatIssues(issues) {
  return issues
    .map((issue) => {
      const path = issue.path.length ? issue.path.join(".") : "root";
      return `${path}: ${issue.message}`;
    })
    .join("\n");
}

export function validateContent(name, schema, data) {
  try {
    return schema.parse(data);
  } catch (error) {
    if (error instanceof ZodError) {
      throw new Error(`Invalid content in ${name}\n${formatIssues(error.issues)}`);
    }
    throw error;
  }
}
